import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navLinks = [{
    to: '/',
    label: 'Home'
  }, {
    to: '/about',
    label: 'About'
  }, {
    to: '/gallery',
    label: 'Gallery'
  }, {
    to: '/booking',
    label: 'Book Now'
  }, {
    to: '/contact',
    label: 'Contact'
  }];
  return <nav className="bg-black border-b border-cyan-500/20 sticky top-0 z-50" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
        <div className="flex justify-between items-center h-20" data-id="element-44">
          <Link to="/" className="flex items-center" data-id="element-45">
            <div className="relative p-2 rounded-lg bg-gradient-to-r from-cyan-500/20 via-blue-500/20 to-green-500/20 shadow-lg shadow-cyan-500/30" data-id="element-46">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5AxcgcJ7MjJtSJauijUyxj/Screenshot_2025-10-26_at_1.40.38_PM.png" alt="Western Royal Diesel and Wrap" className="h-20 w-auto" data-id="element-47" />
            </div>
          </Link>
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-48">
            {navLinks.map(link => <Link key={link.to} to={link.to} className={`text-gray-300 hover:text-cyan-400 transition-colors font-medium ${link.label === 'Book Now' ? 'bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white px-6 py-2 rounded-lg' : ''}`} data-id="element-49">
                {link.label}
              </Link>)}
          </div>
          {/* Mobile Menu Button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-white p-2" data-id="element-50">
            {isMenuOpen ? <XIcon size={24} data-id="element-51" /> : <MenuIcon size={24} data-id="element-52" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden py-4 border-t border-cyan-500/20" data-id="element-53">
            <div className="flex flex-col space-y-4" data-id="element-54">
              {navLinks.map(link => <Link key={link.to} to={link.to} onClick={() => setIsMenuOpen(false)} className={`text-gray-300 hover:text-cyan-400 transition-colors font-medium ${link.label === 'Book Now' ? 'bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-6 py-2 rounded-lg text-center' : ''}`} data-id="element-55">
                  {link.label}
                </Link>)}
            </div>
          </div>}
      </div>
    </nav>;
}